import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const TreeService = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my tree service business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps tree service businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for tree service businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most tree service businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my tree service business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like tree service. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Tree Service - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Tree Service CRM", url: "/industries/tree-service" }
  ];

  const industryData = {
    name: 'Tree Service',
    title: 'Capture Storm Emergency Calls & Build Recurring Maintenance Revenue',
    subtitle: 'Never miss urgent storm damage calls, automate seasonal trimming reminders, and manage large project estimates',
    icon: '🌲',
    challenges: [
      'Missing emergency storm damage calls',
      'Customers forget about seasonal maintenance',
      'Large estimates go cold',
      'Hard to schedule big jobs efficiently',
      'Seasonal revenue fluctuations'
    ],
    solutions: [
      'Emergency storm damage call routing',
      'Automated seasonal maintenance reminders',
      'Large estimate nurture campaigns',
      'Project scheduling automation',
      'Year-round service diversification'
    ],
    features: [
      'Emergency call capture 24/7',
      'Seasonal reminder automation',
      'Large project management',
      'Crew scheduling',
      'Before/after photo galleries',
      'Insurance claim assistance',
      'Review automation',
      'Municipal contract tracking'
    ],
    results: [
      'Capture 100% of storm emergencies',
      '75% recurring maintenance conversion',
      'Close 40% more large projects',
      '£8.3K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Tree Service UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for tree service businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for tree service UK, tree service business software, tree service customer management, tree service lead generation UK"
        url="/industries/tree-service"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default TreeService;